module.exports = __webpack_public_path__ + "static/media/video-back.cdd2b5fd.svg";